import { createContext } from 'react';
import { TokenizedApi } from '@tokenized/sdk-js-private';

/** @internal */
export const tokenizedApiContext = createContext<TokenizedApi | null>(null);
